/**
 * Variáveis de Respostas Prontas — catálogo tipado + resolver puro (S2).
 * Camada 1 (conversa, sempre disponível) · Camada 2 (contrato/ERP, SÓ com
 * identidade verified + cap external-context-sync — regra de ouro anti-vazamento).
 * A resolução de VALORES é server-side (Engine); aqui vive só o puro.
 */
export const CANNED_VARIABLE_CATALOG = [
    {
        name: 'primeiro_nome',
        label: 'Primeiro nome do cliente',
        layer: 1,
        example: 'Marina',
        description: 'Primeiro nome da pessoa da conversa.',
    },
    {
        name: 'nome_cliente',
        label: 'Nome do cliente',
        layer: 1,
        example: 'Marina Duarte',
        description: 'Nome completo da pessoa da conversa.',
    },
    {
        name: 'nome_operador',
        label: 'Nome do operador',
        layer: 1,
        example: 'Diego',
        description: 'Nome de quem envia a resposta.',
    },
    {
        name: 'protocolo',
        label: 'Protocolo da conversa',
        layer: 1,
        example: '01J9…',
        description: 'Identificador único da conversa (decisão TL 17/Jul: Conversation.id).',
    },
    {
        name: 'saudacao_do_dia',
        label: 'Saudação do dia',
        layer: 1,
        example: 'Bom dia',
        description: 'Bom dia/Boa tarde/Boa noite no fuso do tenant.',
    },
    {
        name: 'contrato',
        label: 'Contrato ativo',
        layer: 2,
        example: 'Casa — Fibra 500',
        description: 'Rótulo do vínculo/contrato ativo da conversa. Exige titular verificado.',
    },
    {
        name: 'vencimento_fatura',
        label: 'Vencimento da fatura',
        layer: 2,
        example: '22/07/2026',
        description: 'Vencimento da fatura em aberto (ERP, ao vivo). Exige titular verificado.',
    },
];
export const CANNED_VARIABLE_PATTERN = /\{\{\s*([a-z_][a-z0-9_]*)\s*\}\}/g;
export function extractCannedVariables(text) {
    const seen = new Set();
    const out = [];
    for (const m of text.matchAll(CANNED_VARIABLE_PATTERN)) {
        const name = m[1];
        if (!seen.has(name)) {
            seen.add(name);
            out.push(name);
        }
    }
    return out;
}
export function applyCannedVariables(text, values) {
    const unresolved = [];
    const seen = new Set();
    const result = text.replace(CANNED_VARIABLE_PATTERN, (raw, name) => {
        const n = name;
        const value = values[n];
        if (typeof value === 'string' && value.length > 0)
            return value;
        if (!seen.has(n)) {
            seen.add(n);
            unresolved.push(n);
        }
        return raw;
    });
    return { text: result, unresolved };
}
const FALLBACK_TZ = 'America/Sao_Paulo';
export function computeDaypartGreeting(date, timeZone) {
    let hour;
    try {
        hour = Number(new Intl.DateTimeFormat('pt-BR', { hour: 'numeric', hour12: false, timeZone }).format(date));
    }
    catch {
        hour = Number(new Intl.DateTimeFormat('pt-BR', {
            hour: 'numeric',
            hour12: false,
            timeZone: FALLBACK_TZ,
        }).format(date));
    }
    if (hour >= 5 && hour < 12)
        return 'Bom dia';
    if (hour >= 12 && hour < 18)
        return 'Boa tarde';
    return 'Boa noite';
}
/**
 * Razão de edição operador-vs-original (0 = colou puro, 1 = reescreveu tudo).
 * S2 grava; S4 consome. Levenshtein clássico O(n*m) — textos ≤4000 chars.
 */
export function computeEditDistanceRatio(original, edited) {
    if (original === edited)
        return 0;
    const a = original;
    const b = edited;
    const maxLen = Math.max(a.length, b.length);
    if (maxLen === 0)
        return 0;
    let prev = Array.from({ length: b.length + 1 }, (_, j) => j);
    for (let i = 1; i <= a.length; i++) {
        const curr = [i];
        for (let j = 1; j <= b.length; j++) {
            curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
        prev = curr;
    }
    return Number((prev[b.length] / maxLen).toFixed(2));
}
//# sourceMappingURL=variables.js.map